module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80% !important",
      "text-align": "left !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [(_vm.payment_object.payment_detail_type == 'cninsurance') ? _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2em",
      "margin-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2em",
      "margin-left": "1em"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word",
      "text-align": "left!important"
    }
  }, [_c('div', {
    key: _vm.paymentModalComponentKey,
    staticClass: "container"
  }, [(_vm.payment_object.payment_detail_type != 'general') ? _c('div', {
    staticStyle: {
      "margin-left": "-1.3em",
      "word-wrap": "break-word",
      "text-align": "left !important"
    }
  }, [_c('img', {
    staticClass: "wn-profile-img",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.payment_object.payment_detail_logo
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.payment_object.payment_detail_name))])]) : _c('div', {
    staticStyle: {
      "margin-top": "-2em",
      "margin-left": "-1.3em"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.payment_object.payment_detail_name))])]), _vm._v(" "), (_vm.payment_status > 0) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "word-wrap": "break-word",
      "text-align": "left !important"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "word-wrap": "break-word !important"
    }
  }, [_vm._v(_vm._s(_vm.getModalMessage()))]), _vm._v(" "), (_vm.call_src == 2) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/cnprocesses?type=3"
    }
  }, [_vm._v("Continue")])]) : _c('div', [(_vm.payment_status == 200) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.active_url + _vm.payment_object.payment_detail_set_callbackurl
    }
  }, [_vm._v("Continue")])]) : _vm._e(), _vm._v(" "), (_vm.payment_status == 400) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resolveIssues
    }
  }, [_vm._v("Correct Issues")])]) : _vm._e()])])]) : _c('div', {
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word",
      "text-align": "left !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.formatCurrency(_vm.payment_data.total_amount)))])])]), _vm._v(" "), _c('div', {
    key: _vm.headerKey,
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), ((_vm.user.current_wallet_balance && (_vm.user.current_wallet_balance > _vm.payment_data.total_amount))) ? _c('div', [_c('p', [_c('b', [_vm._v("Current Wallet Balance: ₦" + _vm._s(_vm.formatCurrency_2(_vm.user.current_wallet_balance)))])]), _vm._v(" "), (_vm.payment_process_option == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.payment_process_option == 2,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentOption(2)
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You do not have sufficient funds in your wallet")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process payment from your Bank Account")]), _vm._v(" "), (_vm.payment_process_option == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.payment_process_option == 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentOption(1)
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "formupdate",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    key: _vm.paymentModalComponentKey,
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "wn-profile-img",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.payment_object.payment_detail_logo
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.payment_object.payment_detail_name))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.getModalMessage()))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.active_url + 'account-cninsurance'
    }
  }, [_vm._v("Continue")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("Insure")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("moto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("buy insurance with a click 👌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("city")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("needs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("convenience for living 👌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2em",
      "margin-left": "1em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("Insure")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("moto")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("buy insurance with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c2eae6"}!./src/templates/CNpaymentModal/template.html
// module id = 270
// module chunks = 0